import { isString } from './type-guards.js';

const guard = (fieldName, value, defaultValue)=>{
    if (!value && isString(defaultValue)) {
        return defaultValue;
    }
    if (isString(value)) {
        return value;
    }
    throw new Error(`${fieldName}: value ${value} is not a string`);
};

export { guard };
//# sourceMappingURL=string-guard.js.map
